import { useRef, useState } from "react";
import useClickOutside from "../../hooks/useClickOutside";
import { ChevronDown } from "lucide-react";
import { useGetAIModels } from "../../api/queryHooks";
import { DropdownMenu2 } from "./index";
import useModelPreferences from "../../hooks/useModelPreferences";

const AIModelDropdown = ({
  selectedModel,
  onSelect,
  className,
  containerRef,
  id,
  ...props
}) => {
  const dropdownRef = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const { getEnabledModels } = useModelPreferences();
  const { data: allModels, isLoading } = useGetAIModels();
  const options = getEnabledModels(allModels);

  useClickOutside(dropdownRef, () => setIsOpen(false));

  return (
    <div
      ref={dropdownRef}
      className={`relative cursor-pointer bg-fill-hex-fafbfe dark:bg-fill-navigation-surface-dark w-full text-xs text-ink-ink dark:text-ink-white border-[0.5px] border-edge-hex-aaaaaa dark:border-edge-hex-aaaaaa80 rounded-[10px] ${className}`}
      {...props}
    >
      {isOpen && (
        <DropdownMenu2
          containerRef={containerRef}
          options={options}
          isLoading={isLoading}
          onSelect={(model) => {
            onSelect(model);
            setIsOpen(false);
          }}
        />
      )}
      <button
        id={id}
        type="button"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        className="p-[10px] w-full flex justify-between items-center text-left"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="flex-grow font-semibold truncate">
          {selectedModel ? selectedModel.name : "Select Model"}
        </span>
        <ChevronDown className={`w-3.5 h-3.5 ${isOpen ? "rotate-180" : ""} transition-transform duration-300`} />
      </button>
    </div>
  );
};

export default AIModelDropdown;
